import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SipPopupComponent } from './sip-popup/sip-popup.component';


@NgModule({
  declarations: [SipPopupComponent],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [SipPopupComponent]
})
export class SipPopupModule { }
